// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import VueResource from 'vue-resource'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import store from './store'

import vuexI18n from 'vuex-i18n' // Translation plugin
import translationSv from './translations/sv'
import translationEn from './translations/en'
import translationCz from './translations/cz'
import translationPl from './translations/pl'
import translationGulf from './translations/customers/114'
import translationMace from './translations/customers/124'

import VueNotification from 'vue-notification'
import VueFormGenerator from 'vue-form-generator/dist/vfg.js'
import 'vue-form-generator/dist/vfg.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import Multiselect from 'vue-multiselect'
import VueAnalytics from 'vue-analytics'
import Sortable from 'sortablejs'

/* Vue Table */
import VueTableActions from './components/VueTableActions'
import VueTableJointActions from './components/VueTableJointActions'
import VueTableFlataActions from './components/VueTableFlataActions'
import VueTableSwitch from './components/VueTableSwitch'
import VueTableEquipmentActions from './components/VueTableEquipmentActions'
import VueTableRentalActions from './components/VueTableRentalActions'
import OrderLineCommentField from './components/OrderLineCommentField'
import OrderListActions from './components/OrderListActions'
import VuetableFieldCheckbox from 'vuetable-2/src/components/VuetableFieldCheckbox.vue'
import PicklistListActions from './components/PicklistListActions'

import CustomVueTable from './components/CustomVueTable'
import JointVueTable from './components/JointVueTable'
import JointDetailRow from './components/JointDetailRow'

import JointReport from './components/JointReport'
import JointReportPreview from './components/JointReportPreview'
import JointReportPage from './components/JointReportPage'
import JointReportCoverPage from './components/JointReportCoverPage'

/* Vue Form Generator Custom Fields */
import VfgDatePicker from './components/VfgDatePicker'
import VfgMultiDropDown from './components/VfgMultiDropDown'

import FlagIcon from 'vue-flag-icon'
import VueLayers from 'vuelayers'
import 'vuelayers/lib/style.css'
Vue.use(VueLayers)
Vue.use(FlagIcon)

Vue.directive('sortable', {
  inserted: function (el, binding) {
    var d = new Sortable(el, binding.value || {})
    console.log(d)
  }
})

Vue.component('joint-report', JointReport)
Vue.component('joint-report-preview', JointReportPreview)
Vue.component('joint-report-page', JointReportPage)
Vue.component('joint-report-cover-page', JointReportCoverPage)
Vue.component('joint-detail-row', JointDetailRow)
Vue.component('joint-vue-table', JointVueTable)
Vue.component('vuetable-field-component:vue-table-flata-actions', VueTableFlataActions)
Vue.component('vuetable-field-component:vue-table-joint-actions', VueTableJointActions)
Vue.component('vuetable-field-component:vue-table-equipment-actions', VueTableEquipmentActions)
Vue.component('vuetable-field-component:vue-table-rental-actions', VueTableRentalActions)
Vue.component('vuetable-field-component:vue-table-switch', VueTableSwitch)
Vue.component('custom-vue-table', CustomVueTable)
Vue.component('vuetable-field-component:vue-table-actions', VueTableActions)
Vue.use(require('vuetable-2'))
Vue.component('multiselect', Multiselect)

Vue.component('fieldCustomDatePicker', VfgDatePicker)
Vue.component('fieldCustomMultiDropDown', VfgMultiDropDown)
Vue.component('vuetable-field-component:order-line-table-comment-field', OrderLineCommentField)
Vue.component('vuetable-field-component:order-list-actions', OrderListActions)
Vue.component('vuetable-field-component:picklist-list-actions', PicklistListActions)
Vue.component('vuetable-field-checkbox', VuetableFieldCheckbox)

Vue.router = router

Vue.use(BootstrapVue)
Vue.use(VueResource)
Vue.use(VueFormGenerator)

Vue.use(VueNotification)

Vue.use(require('@websanova/vue-auth'), {
  auth: require('@websanova/vue-auth/drivers/auth/bearer'),
  http: require('@websanova/vue-auth/drivers/http/vue-resource.1.x'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x'),
  loginData: {
    url: 'login',
    method: 'POST',
    redirect: '/dashboard',
    fetchUser: true
  },
  rolesVar: 'role',
  fetchData: { url: 'currentuser?with=companies', method: 'GET', enabled: true },
  refreshData: { url: 'refresh', method: 'GET', enabled: true, interval: 30 },
  parseUserData: function (data) {
    return data
  }
})

Vue.http.options.root = store.getters.apiUrl

/***
 *
 * Localization/Language
 *
 ***/

Vue.use(vuexI18n.plugin, store, {
  onTranslationNotFound (locale, key) {
    // console.log(`'${key}': '',`)
  }// ,
  // preserveState: true
})

Vue.i18n.add('sv', translationSv)
Vue.i18n.add('en', translationEn)
Vue.i18n.add('cz', translationCz)
Vue.i18n.add('pl', translationPl)
Vue.i18n.add('114', translationGulf)
Vue.i18n.add('124', translationMace)

if (typeof JSON.parse(window.localStorage.vuex).currentCompany !== 'undefined' && JSON.parse(window.localStorage.vuex).currentCompany !== null && Vue.i18n.exists(JSON.parse(window.localStorage.vuex).currentCompany.toString())) {
  Vue.i18n.set(JSON.parse(window.localStorage.vuex).currentCompany.toString())
} else if (typeof JSON.parse(window.localStorage.vuex).currentUser.language !== 'undefined') {
  Vue.i18n.set(JSON.parse(window.localStorage.vuex).currentUser.language)
} else {
  Vue.i18n.set('en')
}

Vue.use(VueAnalytics, {
  id: 'UA-120528961-1',
  router
})

/* eslint-disable no-new */
window['vue'] = new Vue({
  el: '#app',
  router: router,
  store: store,
  template: '<App/>',
  components: {
    App
  }
})

Vue.http.interceptors.push(function (response, next) {
  next(function (res) {
    if (res.status === 403) {
      console.log('403')
      Vue.router.push({name: 'Page403'})
    } else if (res.status === 500) {
      window['vue'].$notify({
        group: 'full',
        text: window['vue'].$t('Something went wrong on our end. Please try again or contact support')
      })
    } else if (res.status === 401) {
      window['vue'].$notify({
        group: 'full',
        type: 'warning',
        text: (res.data.msg ? window['vue'].$t(res.data.msg) : window['vue'].$t('Access Denied'))
      })
    } else if (res.status > 400 && res.status < 500) {
      window['vue'].$auth.logout({
        makeRequest: false,
        redirect: '/login',
        success: function () {
          window['vue'].$store.commit('resetState')
        }
      })
    }
  })
})



// WEBPACK FOOTER //
// ./src/main.js